import React from 'react';

const Report = () => {
  return <div data-testid="admin-task-reports"></div>;
};

export default Report;
